// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import file02Icon from "@/assets/icons/file-02.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type File02IconProps = Omit<IconProps, "name">;

export function File02Icon(props: File02IconProps): React.ReactNode {
  return <Icon name={file02Icon} {...props} />;
}
